import React from 'react'
import { Drawer, Hidden } from '@material-ui/core'
import { makeStyles, ThemeProvider } from '@material-ui/styles'
import clsx from 'clsx'
import * as Actions from 'app/store/actions'
import NavbarLayoutMain from './NavbarLayoutMain'
import { useDispatch, useSelector } from 'react-redux'

const navbarWidth = 300

const useStyles = makeStyles((theme) => ({
  wrapper: () => ({
    display: 'flex',
    flexDirection: 'column',
    zIndex: 4,
    [theme.breakpoints.up('lg')]: {
      width: navbarWidth,
      minWidth: navbarWidth,
    },
  }),
  wrapperFolded: () => ({
    [theme.breakpoints.up('lg')]: {
      width: 64,
      minWidth: 64,
    },
  }),
  navbar: () => ({
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    flex: '1 1 auto',
    width: navbarWidth,
    minWidth: navbarWidth,
    height: '100%',
    zIndex: 4,
    transition: theme.transitions.create(['width', 'min-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
    boxShadow: theme.shadows[3],
  }),
  left: () => ({
    left: 0,
  }),
  right: () => ({
    right: 0,
  }),
  folded: () => ({
    position: 'absolute',
    width: 64,
    minWidth: 64,
    top: 0,
    bottom: 0,
  }),
  foldedAndOpened: () => ({
    width: navbarWidth,
    minWidth: navbarWidth,
  }),
  navbarContent: () => ({
    flex: '1 1 auto',
  }),
  foldedAndClosed: () => ({
    '& $navbarContent': {
      '& .logo-icon': {
        width: 32,
        height: 32,
        maxWidth: 'initial',
      },
      '& .logo-text': {
        opacity: 0,
        display: 'none',
      },
      '& .react-badge': {
        opacity: 0,
      },
      '& .list-item-text, & .arrow-icon, & .item-badge': {
        opacity: 0,
      },
      // if UX change to remove space of the main menu THEN uncomment this line
      // '& .mainSidebarMenu': {
      // display: 'none',
      // },
      '& .appBar': {
        paddingLeft: '1.5rem !important',
      },
      '& .subMenuSidebarMenu.active': {
        paddingLeft: '1.8rem !important',
      },
      '& .sendMessageMenu': {
        padding: '0 !important',
      },
      '& .sendMessageButton': {
        borderRadius: '0 !important',
      },
      '& .subMenuSidebarMenu': {
        paddingLeft: '2.4rem !important',
      },
      '& .user': {
        '& .username, & .email': {
          opacity: 0,
        },
        '& .avatar': {
          width: 40,
          height: 40,
          top: 32,
          padding: 0,
        },
      },
    },
  }),
  navBarRight: () => ({
    backgroundColor: 'grey !important',
    right: '0 !important',
    left: '50%',
  }),
}))

function NavbarWrapperLayoutMain() {
  const dispatch = useDispatch()
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config)
  const direction = useSelector(({ fuse }) => fuse.settings.current.direction)
  const navbarTheme = useSelector(({ fuse }) => fuse.settings.navbarTheme)
  const navbar = useSelector(({ fuse }) => fuse.navbar)

  const classes = useStyles()

  const folded = config.navbar.folded
  const foldedAndClosed = folded && !navbar.foldedOpen
  const foldedAndOpened = folded && navbar.foldedOpen
  return (
    <ThemeProvider theme={navbarTheme}>
      <div
        id="fuse-navbar"
        className={clsx(classes.wrapper, folded && classes.wrapperFolded)}
      >
        <Hidden mdDown>
          <div
            className={clsx(
              classes.navbar,
              classes[config.navbar.position],
              folded && classes.folded,
              foldedAndOpened && classes.foldedAndOpened,
              foldedAndClosed && classes.foldedAndClosed,
              direction === 'rtl' && classes.navBarRight,
            )}
            onMouseEnter={() =>
              foldedAndClosed && dispatch(Actions.navbarOpenFolded())
            }
            onMouseLeave={() =>
              foldedAndOpened && dispatch(Actions.navbarCloseFolded())
            }
            style={{ backgroundColor: navbarTheme.palette.background.default }}
          >
            <NavbarLayoutMain
              className={classes.navbarContent}
              foldedAndOpened={foldedAndOpened}
              folded={folded}
            />
          </div>
        </Hidden>

        <Hidden lgUp>
          <Drawer
            anchor={config.navbar.position}
            variant="temporary"
            open={navbar.mobileOpen}
            classes={{
              paper: classes.navbar,
            }}
            onClose={() => dispatch(Actions.navbarCloseMobile())}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <NavbarLayoutMain
              className={classes.navbarContent}
              foldedAndOpened={foldedAndOpened}
              folded={folded}
            />
          </Drawer>
        </Hidden>
      </div>
    </ThemeProvider>
  )
}

export default NavbarWrapperLayoutMain
